export const STATUSES = [
  { key: "new", title: "Новые" },
  { key: "waiting_measure", title: "Ждёт замера" },
  { key: "measuring", title: "Замер" },
  { key: "pricing", title: "Просчёт" },
  { key: "design", title: "Дизайн" },
  { key: "ready", title: "Готово → Производство" },
];
